// extracted by mini-css-extract-plugin
export var container = "_3z-0";
export var disabled = "_3z-4";
export var fullWidth = "_3z-3";
export var lined = "_3z-1";
export var selected = "_3z-5";
export var tab = "_3z-2";